/*
 * ping-sample-web-react-todo-oidc
 *
 * home.js
 *
 * Copyright (c) 2026 Ping Identity Corporation. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import { OidcContext } from '../context/oidc.context';
import { ThemeContext } from '../context/theme.context';
import VerifiedIcon from '../components/icons/verified-icon';

/**
 * @function Home - React view for Home
 * @returns {Object} - React component object
 */
export default function Home() {
  /**
   * Collects the global state for detecting user auth for rendering
   * appropriate navigational items.
   * The destructuring of the hook's array results in index 0 having the state value,
   * and index 1 having the "setter" method to set new state values.
   */
  const [oidcState] = useContext(OidcContext);
  const theme = useContext(ThemeContext);

  const LoginAlert = oidcState.isAuthenticated ? (
    <p className="alert alert-success d-flex align-items-center mt-5" role="alert">
      <VerifiedIcon classes="cstm_verified-alert-icon" size="36px" />
      <span className="ps-2">
       Welcome back, {oidcState.username}!{' '}
      </span>
    </p>
  ) : null;

 /*   const ManageProfile = oidcState.isAuthenticated ? (
      <p className={`cstm_subhead-text fs-3 mb-4 fw-bold ${theme.textMutedClass}`}>
        Gerencie aqui seu Perfil{''}<br></br>
        <a className={`${theme.textMutedClass}`}
          href="https://qas-mc.lab.qriardemo.digital/enduser-ui/?realm=alpha#/dashboard">
          Gerenciar Perfil
        </a>{' '}
        <br></br>Acessar Demo APP 2{''}<br></br>
        <a className={`${theme.textMutedClass}`}
          href="https://localhost:8444">
          Acessar Demo APP 2
        </a>{' '}        
      </p>
      
  ) : null;
*/
  return (
    <div className={`cstm_container container-fluid ${theme.textClass}`}>
      {LoginAlert}
      <h1 className={`cstm_head-text text-center ${theme.textClass}`}>Ping AIS Qriar Sample</h1>
    </div>
  );
}
